export default function cancelAgentPolling(context) {
  context.gateways.conversationCount.unsubscribeFromAgentConversationCounts();
  context.gateways.routableInboxCounts.unsubscribeFromRoutableCounts();
}
